module.exports = __webpack_public_path__ + "img/cube-04.2cc3f316.svg";